import keyMirror from 'react-utils/keyMirror'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'flux... Remove this comment to see the full error message

import { createAction } from 'flux-actions';
export const AccountsActionTypes = keyMirror({
  FILTER_ACCOUNTS: null
});
export const filterAccounts = createAction(AccountsActionTypes.FILTER_ACCOUNTS, filter => ({
  filter
}));